import React from "react";

/**
 * İTSO logo that adapts to theme:
 * - black logo in light mode
 * - white logo in dark mode
 * Both variants are preloaded via <img>; visibility is toggled with the
 * Tailwind `dark:` class so it switches instantly with the theme.
 */
export default function Logo({ className = "h-9 w-9" }) {
  return (
    <>
      <img
        src="/itso-logo.png"
        alt="İnegöl Ticaret ve Sanayi Odası"
        className={`${className} object-contain block dark:hidden`}
        draggable={false}
      />
      <img
        src="/itso-logo-white.png?v=2"
        alt="İnegöl Ticaret ve Sanayi Odası"
        className={`${className} object-contain hidden dark:block`}
        draggable={false}
      />
    </>
  );
}
